// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"eed3bf2e","371":"9b1a5d96","560":"02030c4e","963":"0d40a6a5","978":"ff015b0d","984":"084d047f"}[chunkId] + ".chunk.js";
};